export const ACCESS_TOKEN = "accessToken";
export const USER_ROLES = "userRoles";
export const XSRF_TOKEN = "XSRF-TOKEN";
